import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'

import AchievementsSkeleton from './AchievementsSkeleton'

const Achievements = ({
  progressSection,
  liveLessonSection,
  mediaSection,
  writingSection,
  conceptsSection,
  certSection,
  flashcardsSection,
  allTimeStatsSection,
  leaderboardSection,
}) => {
  return (
    <AchievementsSkeleton
      headerSection={t('Achievements')}
      allTimeStatsSection={allTimeStatsSection}
      progressSection={progressSection}
      liveLessonSection={liveLessonSection}
      mediaSection={mediaSection}
      writingSection={writingSection}
      flashcardsSection={flashcardsSection}
      conceptsSection={conceptsSection}
      certSection={certSection}
      leaderboardSection={leaderboardSection}
    />
  )
}

Achievements.propTypes = {
  progressSection: PropTypes.any,
  flashcardsSection: PropTypes.any,
  allTimeStatsSection: PropTypes.any,
  liveLessonSection: PropTypes.any,
  mediaSection: PropTypes.any,
  writingSection: PropTypes.any,
  conceptsSection: PropTypes.any,
  certSection: PropTypes.any,
  leaderboardSection: PropTypes.any,
}

export default Achievements
